var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPagoTienda({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 29,
    viewBox: "0 0 31 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.4125 25.7732H0.515445C0.230932 25.7732 0 26.0036 0 26.2886V28.3505C0 28.6356 0.230932 28.866 0.515445 28.866H30.4124C30.6975 28.866 30.9279 28.6356 30.9279 28.3505V26.2887C30.9279 26.0036 30.6975 25.7732 30.4125 25.7732ZM29.897 27.8351H1.03095V26.8041H29.897L29.897 27.8351Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.399 8.6377L28.8526 2.45211C28.7949 2.22323 28.5892 2.06189 28.3527 2.06189H2.57938C2.34276 2.06189 2.1366 2.22323 2.07939 2.45211L0.532999 8.6377C0.494339 8.79179 0.529374 8.95471 0.626809 9.07999C0.724245 9.20527 0.874233 9.27842 1.03298 9.27842H29.8991C30.0578 9.27842 30.2073 9.20521 30.3052 9.07999C30.4031 8.95477 30.4377 8.79179 30.399 8.6377ZM1.69328 8.24747L2.98192 3.09284H27.9501L29.2387 8.24747H1.69328Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0105 8.76294V9.79389C17.0105 10.6465 16.3166 11.3403 15.4641 11.3403C14.6115 11.3403 13.9177 10.6465 13.9177 9.79389V8.76294H12.8867V9.79389C12.8867 11.215 14.0429 12.3712 15.4641 12.3712C16.8852 12.3712 18.0414 11.2151 18.0414 9.79389V8.76294H17.0105Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8874 8.76282V9.79377C12.8874 10.6463 12.1936 11.3402 11.341 11.3402C10.4884 11.3402 9.79462 10.6463 9.79462 9.79377V8.76282H8.76367V9.79377C8.76367 11.2149 9.91984 12.3711 11.341 12.3711C12.7621 12.3711 13.9184 11.2149 13.9184 9.79377V8.76282H12.8874Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.76437 8.76294V9.79389C8.76437 10.6465 8.07054 11.3403 7.21797 11.3403C6.3654 11.3403 5.67158 10.6465 5.67158 9.79389V8.76294H4.64062V9.79389C4.64062 11.215 5.7968 12.3712 7.21797 12.3712C8.63915 12.3712 9.79532 11.2151 9.79532 9.79389V8.76294H8.76437Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64132 8.76282V9.79377C4.64132 10.6463 3.9475 11.3402 3.09492 11.3402C2.24235 11.3402 1.54853 10.6463 1.54853 9.79377V8.76282H0.517578V9.79377C0.517578 11.2149 1.67375 12.3711 3.09492 12.3711C4.51604 12.3711 5.67227 11.2149 5.67227 9.79377V8.76282H4.64132Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3816 8.76294V9.79389C29.3816 10.6465 28.6877 11.3403 27.8352 11.3403C26.9826 11.3403 26.2888 10.6465 26.2888 9.79389V8.76294H25.2578V9.79389C25.2578 11.215 26.414 12.3712 27.8352 12.3712C29.2563 12.3712 30.4125 11.2151 30.4125 9.79389V8.76294H29.3816Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2605 8.76294V9.79389C25.2605 10.6465 24.5666 11.3403 23.7141 11.3403C22.8615 11.3403 22.1677 10.6465 22.1677 9.79389V8.76294H21.1367V9.79389C21.1367 11.215 22.2929 12.3712 23.7141 12.3712C25.1352 12.3712 26.2914 11.2151 26.2914 9.79389V8.76294H25.2605Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1335 8.76282V9.79377C21.1335 10.6463 20.4397 11.3402 19.5871 11.3402C18.7345 11.3402 18.0407 10.6463 18.0407 9.79377V8.76282H17.0098V9.79377C17.0098 11.2149 18.1659 12.3711 19.5871 12.3711C21.0082 12.3711 22.1645 11.2149 22.1645 9.79377V8.76282H21.1335Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9177 2.57727H12.8867V8.76285H13.9177V2.57727Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0407 2.57751H17.0098V8.7631H18.0407V2.57751Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.28071 2.53667L8.76562 8.72083L9.79291 8.80639L10.308 2.62223L9.28071 2.53667Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M5.67876 2.49222L4.64648 8.67834L5.66341 8.84804L6.69569 2.66191L5.67876 2.49222Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6459 2.53533L20.6191 2.62085L21.1342 8.80501L22.161 8.71949L21.6459 2.53533Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2533 2.49213L24.2363 2.66162L25.2673 8.84751L26.2842 8.67802L25.2533 2.49213Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3512 0H2.57795C2.29343 0 2.0625 0.230933 2.0625 0.515445V2.57729H3.09339V1.03089H27.8357V2.57729H28.8667V0.515445C28.8667 0.230933 28.6362 0 28.3512 0Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M3.09345 11.8558H2.0625V25.7734H3.09345V11.8558Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8649 11.8555H27.834V26.2885H28.8649V11.8555Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0735 14.4329H4.64045C4.35593 14.4329 4.125 14.6632 4.125 14.9483V23.1957C4.125 23.4808 4.35593 23.7112 4.64045 23.7112H19.0735C19.3585 23.7112 19.5889 23.4808 19.5889 23.1957V14.9483C19.589 14.6632 19.3585 14.4329 19.0735 14.4329ZM18.558 22.6803H5.15589V15.4638H18.558V22.6803Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2892 14.4331H21.1346C20.8495 14.4331 20.6191 14.6635 20.6191 14.9485V26.2888C20.6191 26.5738 20.8495 26.8042 21.1346 26.8042H26.2892C26.5743 26.8042 26.8047 26.5738 26.8047 26.2888V14.9485C26.8047 14.6635 26.5743 14.4331 26.2892 14.4331ZM25.7738 25.7733H21.65V15.4641H25.7738V25.7733Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M9.43103 16.6455L7.36914 18.7074L8.09813 19.4364L10.16 17.3745L9.43103 16.6455Z",
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0395 16.1288L8.40039 20.7679L9.12938 21.4969L13.7685 16.8578L13.0395 16.1288Z",
    fill: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0697 18.7079L12.0078 20.7698L12.7368 21.4988L14.7987 19.4369L14.0697 18.7079Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPagoTienda);
export default __webpack_public_path__ + "static/media/pago-tienda.319c01a276ed39d353c088c665d45066.svg";
export { ForwardRef as ReactComponent };